import apiClient from './apiClient';

const messagingApi = {
  getConversations: (params?: { cursor?: string; limit?: number }) =>
    apiClient.get('/messaging/conversations', { params }).then((r) => r.data),

  openConversation: (recipientId: string) =>
    apiClient
      .post('/messaging/conversations/open', { recipientId }, { skipSubscriptionRedirect: true })
      .then((r) => r.data),

  startConversation: (
    recipientId: string,
    message: string,
    messageType?: string,
    storyMediaUrl?: string,
    storyMediaType?: string,
  ) =>
    apiClient
      .post('/messaging/conversations', { recipientId, message, messageType, storyMediaUrl, storyMediaType })
      .then((r) => r.data),

  getMessages: (conversationId: string, params?: { cursor?: string; limit?: number }) =>
    apiClient.get(`/messaging/conversations/${conversationId}/messages`, { params }).then((r) => r.data),

  sendMessage: (conversationId: string, content: string) =>
    apiClient.post(`/messaging/conversations/${conversationId}/messages`, { content }).then((r) => r.data),

  markRead: (conversationId: string) =>
    apiClient.patch(`/messaging/conversations/${conversationId}/read`).then((r) => r.data),

  sendVoiceMessage: (conversationId: string, audioBlob: Blob, duration: number) => {
    const form = new FormData();
    form.append('audio', audioBlob, 'voice.webm');
    form.append('duration', String(duration));
    return apiClient.post(`/messaging/conversations/${conversationId}/voice`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data);
  },
};

export default messagingApi;
